import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { getSelectedCell, cellsActions } from '../../../core/cells';
import { getSelectedGeneration } from '../../../core/generations';

import { _Label, _Field } from '../styled-sidebar';
import ColorPicker from '../../common/color-picker';
import StyledColorBlock from '../../common/styled-color-block';
import { StyledScrollable, StyledMargin } from '../../common/styled-base';
import theme from '../../../styles/theme';

import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { colorToString, convertToHumanReadable, convertFromHumanReadable } from '../../../core/utils';

class CellMenu extends React.Component {

  render() {
    const { 
      cell, 
      generation, 
      setName, 
      setBirth, 
      setDeath, 
      setInverted, 
      setBackground, 
      setTextColor, 
    } = this.props;

    return (
      <StyledScrollable padding='15px'>        
        <_Field>
          <_Label>Name:</_Label>

          <TextField
            className="kt-textarea"
            id="name"
            multiLine={true}
            rows={2}
            value={convertToHumanReadable(generation.cellType, cell.name || '')}
            underlineFocusStyle={{ borderColor: theme.primary }}
            onChange={(e, value) =>
              setName(cell.ascendancy, convertFromHumanReadable(generation.cellType, value))
            }
          />
        </_Field>

        <_Field>
          <_Label>Birth:</_Label>
          <TextField 
            id="birth" 
            className="kt-textfield"
            value={cell.birth || ''} 
            inputStyle={{color: 'rgba(255,255,255,0.8'}}
            underlineFocusStyle={{borderColor: theme.primary}}
            onChange={(e, value) => setBirth(cell.ascendancy, value)} 
            />
        </_Field>

        <_Field>
          <_Label>Death:</_Label>
          <TextField 
            id="death" 
            className="kt-textfield"
            value={cell.death || ''} 
            inputStyle={{color: 'rgba(255,255,255,0.8'}}
            underlineFocusStyle={{borderColor: theme.primary}}
            onChange={(e, value) => setDeath(cell.ascendancy, value)} 
            />
        </_Field>

        <div>
          <_Label>Text Inverted:</_Label>
          <SelectField
            className="kt-select"
            value={cell.inverted}
            labelStyle={{color: 'rgba(255,255,255,0.8)'}}
            selectedMenuItemStyle={{color: theme.primary}}
            onChange={(e, index, value) => setInverted(cell.ascendancy, value)}
            >
            <MenuItem value={false} primaryText="No" />
            <MenuItem value={true} primaryText="Yes" />
          </SelectField>
        </div>

        <_Field>
          <_Label>Background Color</_Label>
          <StyledMargin marginTop="5px">
            <ColorPicker color={cell.background} onChange={(color) => setBackground(cell.ascendancy, colorToString(color))}>
              <StyledColorBlock color={cell.background} />
            </ColorPicker>
          </StyledMargin>
        </_Field>

        <_Field>
          <_Label>Text Color</_Label>
          <StyledMargin marginTop="5px">
            <ColorPicker color={cell.textColor} onChange={(color) => setTextColor(cell.ascendancy, colorToString(color))}>
              <StyledColorBlock color={cell.textColor} />
            </ColorPicker>
          </StyledMargin>
        </_Field>
        
      </StyledScrollable>
    )
  }
}

const mapStateToProps = createSelector(
  getSelectedCell,
  getSelectedGeneration,
  (cell, generation) => ({
    cell,
    generation,
  })  
)

const mapDispatchToProps = Object.assign({}, cellsActions)
export default connect(mapStateToProps, mapDispatchToProps)(CellMenu);


// WEBPACK FOOTER //
// ./src/components/menu/cell-menu/index.js